import React from "react";
import { ButtonOutline } from "../buttons";
import { FormDashboardInput } from "./input";

const PinPointFallback = ({ value, onSubmit = () => {} }) => {
  const [show, setShow] = React.useState(true)
  const [latLng, setLatLng] = React.useState(value ? value : {
    lat: null,
    lng: null,
  });

  const handleSubmit = () => {
    onSubmit({
      fallback: true,
      data: latLng
    });
    setShow(false)
  };

  const handleChange = (e) => {
    setLatLng({
      ...latLng,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="px-5 lg:px-0">
      {
        show &&
        <>
          <div className="flex flex-wrap -mx-4 mb-4">
            <div className="w-full lg:w-1/2 px-4 mb-4 lg:mb-0">
              <FormDashboardInput
                className="w-full"
                type="number"
                placeholder="Latitude"
                name="lat"
                onChange={handleChange}
              />
            </div>
            <div className="w-full lg:w-1/2 px-4">
              <FormDashboardInput
                className="w-full"
                type="number"
                placeholder="Longitude"
                name="lng"
                onChange={handleChange}
              />
            </div>
          </div>
          <ButtonOutline onClick={handleSubmit}>
            Submit Pin Point
          </ButtonOutline>
        </>
      }
      {
        !show &&
        <div className="text-gray-text text-sm">
          <p>Latitude: {latLng.lat}</p>
          <p>Longitude: {latLng.lng}</p>
        </div>
      }
    </div>
  );
};

export { PinPointFallback };
